import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import NetworkError from 'shared/exceptions/network';
import { TransactionsSchema } from '../types/transactionsSchema';
import {
  fetchRespondentTransactions,
  withdrawRespondentTransactions,
} from '../services/transactionsService';

const initialState: TransactionsSchema = {
  transactions: {
    data: [],
    // meta: {},
    loading: false,
    init: false,
    withdraw: {
      loading: false,
      modalOpen: false,
    },
  },
};

export const transactionsSlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    onOpenModal(state) {
      state.transactions.withdraw.modalOpen = true;
    },
    onCloseModal(state) {
      state.transactions.withdraw = initialState.transactions.withdraw;
    },
  },
  extraReducers: builder => {
    //GET
    //fetchRespondentProfile
    builder
      .addCase(fetchRespondentTransactions.pending, state => {
        state.transactions.loading = true;
        state.transactions.error = undefined;
      })
      .addCase(fetchRespondentTransactions.fulfilled, (state, action) => {
        state.transactions.loading = false;
        state.transactions.error = undefined;
        //@ts-ignore
        state.transactions.data = action.payload.data.data;
        //@ts-ignore
        state.transactions.meta = action.payload.data.meta;
        state.transactions.init = true;
      })
      .addCase(fetchRespondentTransactions.rejected, (state, action) => {
        state.transactions.loading = false;

        const message = (action.payload as NetworkError).message;
        if (message !== 'axios_cancel') {
          state.transactions.error = {
            ...(action.payload as NetworkError),
            message,
          };
        }
      });

    //PUT
    //withdrawRespondentTransactions
    builder
      .addCase(withdrawRespondentTransactions.pending, state => {
        state.transactions.withdraw.loading = true;
        state.transactions.withdraw.error = undefined;
      })
      .addCase(withdrawRespondentTransactions.fulfilled, state => {
        state.transactions.withdraw.loading = false;
        state.transactions.withdraw.error = undefined;
        state.transactions.withdraw.modalOpen = false;
        state.transactions.init = true;
      })
      .addCase(withdrawRespondentTransactions.rejected, (state, action) => {
        state.transactions.withdraw.loading = false;

        const message = (action.payload as NetworkError).message;
        if (message !== 'axios_cancel') {
          state.transactions.withdraw.error = {
            ...(action.payload as NetworkError),
            message,
          };
        }
      });
  },
});
export const { actions: transactionsActions } = transactionsSlice;
export const { reducer: transactionsReducer } = transactionsSlice;
